import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { InnerHero } from '@/components/sections'
import { LocalizedLink } from '@/components/LocalizedLink'

export function SitemapPage() {
  const { t } = useTranslation('common')

  const sitemapColumns = [
    {
      titleKey: 'sitemap.columns.prodotti.title',
      links: [
        { labelKey: 'sitemap.columns.prodotti.novita', routeKey: 'productsNovita' as const },
        { labelKey: 'sitemap.columns.prodotti.capelli', routeKey: 'productsHair' as const },
        { labelKey: 'sitemap.columns.prodotti.corpo', routeKey: 'productsCorpo' as const },
        { labelKey: 'sitemap.columns.prodotti.viso', routeKey: 'productsViso' as const },
        { labelKey: 'sitemap.columns.prodotti.fragranze', routeKey: 'productsFragranze' as const },
        { labelKey: 'sitemap.columns.prodotti.uomo', routeKey: 'productsUomo' as const },
      ],
    },
    {
      titleKey: 'sitemap.columns.storeSalon.title',
      links: [
        { labelKey: 'sitemap.columns.storeSalon.saloni', routeKey: 'salon' as const },
        { labelKey: 'sitemap.columns.storeSalon.storeLocator', routeKey: 'storeLocator' as const },
        { labelKey: 'sitemap.columns.storeSalon.regaliAziendali', routeKey: 'regaliAziendali' as const },
      ],
    },
    {
      titleKey: 'sitemap.columns.azienda.title',
      links: [
        { labelKey: 'sitemap.columns.azienda.mondoNashi', routeKey: 'world' as const },
        { labelKey: 'sitemap.columns.azienda.news', routeKey: 'news' as const },
        { labelKey: 'sitemap.columns.azienda.lavoraConNoi', routeKey: 'lavoraConNoi' as const },
      ],
    },
    {
      titleKey: 'sitemap.columns.servizioClienti.title',
      links: [
        { labelKey: 'sitemap.columns.servizioClienti.contattaci', routeKey: 'contacts' as const },
        { labelKey: 'sitemap.columns.servizioClienti.faq', routeKey: 'faq' as const },
        { labelKey: 'sitemap.columns.servizioClienti.eGiftCard', routeKey: 'eGiftCard' as const },
      ],
    },
    {
      titleKey: 'sitemap.columns.legal.title',
      links: [
        { labelKey: 'sitemap.columns.legal.privacy', routeKey: 'privacy' as const },
        { labelKey: 'sitemap.columns.legal.cookiePolicy', routeKey: 'cookiePolicy' as const },
        { labelKey: 'sitemap.columns.legal.regolamento', routeKey: 'regolamento' as const },
        { labelKey: 'sitemap.columns.legal.condizioniWelcomeBox', routeKey: 'condizioniWelcomeBox' as const },
      ],
    },
    {
      titleKey: 'sitemap.columns.partner.title',
      links: [
        { labelKey: 'sitemap.columns.partner.diventaPartner', routeKey: 'diventaPartner' as const },
        { labelKey: 'sitemap.columns.partner.nashiLoversClub', routeKey: 'nashiLoversClub' as const },
      ],
    },
  ]

  return (
    <main>
      <InnerHero
        eyebrow={t('sitemap.hero.eyebrow')}
        title={t('sitemap.hero.title')}
        titleItalic={t('sitemap.hero.titleItalic')}
        body={t('sitemap.hero.body')}
        breadcrumbs={[
          { label: t('breadcrumbs.home'), href: '/it' },
          { label: t('sitemap.hero.breadcrumb') },
        ]}
      />

      <section className="bg-cream py-20 md:py-28">
        <div className="nashi-container">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16">
            {sitemapColumns.map((column, idx) => (
              <motion.div
                key={column.titleKey}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.8, delay: idx * 0.1 }}
              >
                <p className="text-[10px] uppercase tracking-[0.32em] text-argan-deep font-medium mb-6">
                  {t(column.titleKey)}
                </p>
                <ul className="space-y-3">
                  {column.links.map((link) => (
                    <li key={link.routeKey}>
                      <LocalizedLink
                        to={link.routeKey}
                        className="text-sm text-bruno-soft hover:text-bruno transition-colors"
                      >
                        {t(link.labelKey)}
                      </LocalizedLink>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

    </main>
  )
}
